// RND-5: quadtree kept in sync with the doc via the command stream (incremental).
import { Quadtree } from "../core/quadtree";
import { boundsValid } from "../core/geometry";
import type { Doc } from "../doc/entities";
import type { Command } from "../doc/commands";
import { entityBounds } from "./bounds";

export class SpatialIndex {
  readonly tree = new Quadtree();

  rebuild(doc: Doc): void {
    this.tree.clear();
    for (const entity of Object.values(doc.entities)) this.insertEntity(doc, entity.id);
  }

  private insertEntity(doc: Doc, id: string): void {
    const entity = doc.entities[id];
    if (!entity || entity.type === "group") return; // groups index via their children (RND-5)
    const b = entityBounds(entity, doc);
    if (boundsValid(b)) this.tree.insert(id, b);
  }

  /** Apply the same command the doc just received (store listener). */
  applyCommand(doc: Doc, cmd: Command): void {
    switch (cmd.kind) {
      case "addEntities":
        for (const e of cmd.entities) this.insertEntity(doc, e.id);
        break;
      case "deleteEntities":
        for (const r of cmd.removed) this.tree.remove(r.entity.id);
        break;
      case "updateEntities":
        for (const p of cmd.patches) this.insertEntity(doc, p.id);
        break;
      case "batch":
        for (const c of cmd.commands) this.applyCommand(doc, c);
        break;
      case "reorder":
      case "addLayer":
      case "deleteLayer":
      case "updateLayer":
      case "setDocProps":
        break; // no geometry change
    }
  }
}
